import React from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'react-bootstrap';

import Source from '../Source';
import MapProperties from '../../map/Properties';

import store from '../../../store/configureStore';

import AirQualityData from '../../data/airQuality/index';
import AirResultToAirQuality from './interfaces/AirResultToAirQuality';

let fetchedData = {};

export default class AirSource extends Source {
  currentView = new MapProperties();
  isLoading = false;
  loadComplete = false;
  url = 'https://rbndapi.cloudhop.in/es/aqm/_search';
  coverage = [];
  constructor(initializer = {}) {
    super(initializer);
    Object.assign(this, initializer);
    this.fetchData();
  }
  fetchData() {
    let url = 'https://rbndapi.cloudhop.in/es/aqm/_search';
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        fetchedData['aqmResults'] = data.hits.hits[0]._source.results;
        fetchedData['aqmMeta'] = data.hits.hits[0]._source.meta;
      });
    url = "https://rbndapi.cloudhop.in/es/iotaqm/_search?size=1000";
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        fetchedData['iotAqmHits'] = data.hits.hits;
      });
  }
  initialize() {
    if (store) {
      store.subscribe(AirSource.onMoveMap);
    }
  }
  setLoadingFlag() {
    this.isLoading = true;
    this.loadComplete = false;
  }
  unsetLoadingFlag() {
    this.isLoading = false;
    this.loadComplete = true;
  }
  static processData(iotAqmHits, aqmResults, aqmMeta) {
    let unit = "µg/m³";
    let iotAqmSource = [];
    iotAqmHits.forEach(element => {
      iotAqmSource.push(element._source);
    })
    let iotAqmResults = [];
    iotAqmSource.forEach((element) => {
      iotAqmResults.push({
        "type": "iotAqm",
        "location": element.channel.channel.name,
        "description": element.channel.channel.description,
        "coordinates": {
          "latitude": Number(element.channel.channel.latitude),
          "longitude": Number(element.channel.channel.longitude)
        },
        "last_write_at": element.channel.channel.last_write_at,
        "measurements": []
      })
    })
    iotAqmSource.map((element, index) => {
      iotAqmResults[index].measurements.push(
        {
          "parameter": element.channel.channel.field1,
          "value": Number(element.feed.field1),
          "unit": unit,
          "lastUpdated": element.channel.channel.last_write_at
        },
        {
          "parameter": element.channel.channel.field2,
          "value": Number(element.feed.field2),
          "unit": unit,
          "lastUpdated": element.channel.channel.last_write_at
        },
        {
          "parameter": element.channel.channel.field3,
          "value": Number(element.feed.field3),
          "unit": unit,
          "lastUpdated": element.channel.channel.last_write_at
        },
        {
          "parameter": element.channel.channel.field4,
          "value": Number(element.feed.field4),
          "unit": unit,
          "lastUpdated": element.channel.channel.last_write_at
        },
        {
          "parameter": element.channel.channel.field5,
          "value": Number(element.feed.field5),
          "unit": unit,
          "lastUpdated": element.channel.channel.last_write_at
        },
        {
          "parameter": element.channel.channel.field6,
          "value": Number(element.feed.field6),
          "unit": unit,
          "lastUpdated": element.channel.channel.last_write_at
        },
        {
          "parameter": element.channel.channel.field7,
          "value": Number(element.feed.field7),
          "unit": unit,
          "lastUpdated": element.channel.channel.last_write_at
        },
        {
          "parameter": element.channel.channel.field8,
          "value": Number(element.feed.field8),
          "unit": unit,
          "lastUpdated": element.channel.channel.last_write_at
        }
      )
    })
    iotAqmResults.forEach(element => {
      aqmResults.push(element);
    })
    aqmMeta.found = aqmMeta.found + iotAqmResults.length;
  }
  static processFinalData(openAQ, currentView) {
    let aqmData = {
      "meta": fetchedData['aqmMeta'],
      "results": fetchedData['aqmResults']
    }
    AirSource.processData(fetchedData['iotAqmHits'], fetchedData['aqmResults'], fetchedData['aqmMeta']);
    new AirResultToAirQuality(aqmData, openAQ.source.uid);
    store.dispatch({
      type: AirSource.ACTIONS.OPENAQ_DATA_LOAD_COMPLETE,
      view: currentView,
      data: aqmData
    });
    store.dispatch({
      type: AirQualityData.ACTIONS.UNLOCK_AIR_QUALITY_RENDERING,
      id: openAQ.source.uid
    });
  }
  static onMoveMap() {
    if (!((store.getState()).viewSettings["air"]))
      return;
    let currentView = (store.getState()).map;
    let openAQ = (store.getState()).openAQ;
    // if ((openAQ.source.currentView !== currentView ) && (!openAQ.source.isLoading)) {
    if (!openAQ.source.isLoading) {
      let area_already_covered = false;
      for (var i = 0; i < openAQ.source.coverage.length; i++) {
        let center = (openAQ.source.coverage[i]).center;
        let radius = (openAQ.source.coverage[i]).radius;
        let lat1 = center.lat,
          lng1 = center.lng,
          lat2 = currentView.view.center.lat,
          lng2 = currentView.view.center.lng;
        let φ1 = (parseFloat(lat1) / 180) * Math.PI,
          φ2 = (parseFloat(lat2) / 180) * Math.PI,
          Δλ = (parseFloat(lng2 - lng1) / 180) * Math.PI,
          R = 6371e3;
        let d = Math.acos(
          Math.sin(φ1) * Math.sin(φ2) +
          Math.cos(φ1) * Math.cos(φ2) * Math.cos(Δλ)) * R;
        if (d <= (radius * 1.5)) {
          area_already_covered = true;
          break;
        }
      }
      if (!area_already_covered) {
        store.dispatch({
          type: AirSource.ACTIONS.BEGIN_OPENAQ_DATA_LOAD
        });
        store.dispatch({
          type: AirQualityData.ACTIONS.LOCK_AIR_QUALITY_RENDERING,
          id: openAQ.source.uid
        });
        if (fetchedData['aqmResults'] === undefined || fetchedData['aqmMeta'] === undefined) {
          //Fetch AQM Data for OpenAQ
          fetch(openAQ.source.url)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              fetchedData['aqmResults'] = data.hits.hits[0]._source.results;
              fetchedData['aqmMeta'] = data.hits.hits[0]._source.meta;
              let aqmResults = data.hits.hits[0]._source.results;
              let aqmMeta = data.hits.hits[0]._source.meta;
              // Fetch IOTAQM Data
              openAQ.source.url = "https://rbndapi.cloudhop.in/es/iotaqm/_search?size=1000";
              fetch(openAQ.source.url)
                .then((response) => {
                  return response.json();
                })
                .then((data) => {
                  fetchedData['iotAqmHits'] = data.hits.hits;
                  AirSource.processFinalData(openAQ, currentView);
                });
            });
        } else {
          if (fetchedData['iotAqmHits'] === undefined) {
            fetch(openAQ.source.url)
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                fetchedData['iotAqmHits'] = data.hits.hits;
                AirSource.processFinalData(openAQ, currentView);
              });
          } else {
            AirSource.processFinalData(openAQ, currentView);
          }

        }
      }
    }
  }
  static get ACTIONS() {
    return {
      BEGIN_OPENAQ_DATA_LOAD: 'BEGIN_OPENAQ_DATA_LOAD',
      OPENAQ_DATA_LOAD_COMPLETE: 'OPENAQ_DATA_LOAD_COMPLETE'
    };
  }
  static reducer(state = {}, action) {
    switch (action.type) {
      case AirSource.ACTIONS.BEGIN_OPENAQ_DATA_LOAD: {
        let source = new AirSource(state.source);
        source.setLoadingFlag();
        return Object.assign({}, state, {
          source: source
        });
      }
      case AirSource.ACTIONS.OPENAQ_DATA_LOAD_COMPLETE: {
        let source = new AirSource(state.source);
        source.unsetLoadingFlag();
        source.currentView = action.view;
        source.coverage = ([].concat(source.coverage)).concat([
          {
            center: Object.assign({}, action.view.view.center),
            radius: action.view.view.radius,
          }
        ]);
        source.data = action.data;
        return Object.assign({}, state, {
          source: source
        });
      }
      default: {
        return state;
      }
    }
  }
}

class OpenAQDataLOC extends React.Component {
  constructor() {
    super();
  }
  render() {
    let data = this.props.openAQ.source.data;
    if ((data) && (data.results) && (data.results.length > 0)) {
      return <Carousel>
        {
          data.results.map((aqItem) => {
            <Carousel.Item key={Math.random()}>
              <div>Data Item</div>
              <Carousel.Caption>
                <h3>First slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
              </Carousel.Caption>
            </Carousel.Item>
          })
        }
      </Carousel>;
    }
    return <div>
      No OpenAQ Feed in this area
    </div>;
  }
}

const OpenAQDataViewer = connect((state) => {
  return {
    openAQ: state.openAQ
  };
})(OpenAQDataLOC);

export { OpenAQDataViewer };



// WEBPACK FOOTER //
// ./src/models/source/air/index.js